<template>
  <div class="ut-relative">
    <div class="checkbox-group ut-m-3 ut-flex ut-justify-start ut-items-center"
        :class="[classes]"
        @click="toggle()">
        <input type="checkbox"
          :id="id"
          :name="name"
          :value="checkboxValue"
          :disabled="disabled"
          :required="required"
          :checked="checkboxState"
          @change="toggle()">
          <svg-loader name="icon-check"
                      :width="12"
                      class="icon"></svg-loader>
          <label class="ut-ml-3 ut-cursor-pointer ut-text-neutral-400"
            :name="name"
            :for="id">
            <slot/>
          </label>
  </div>
  </div>
</template>

<script>
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';

export default {
  name: 'CheckboxStandard',
  components: {
    SvgLoader,
  },
  model: {
    prop: 'model',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    model: {
      default: undefined,
    },
    checked: {
      type: Boolean,
      required: false,
    },
    checkboxValue: {
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: 'default',
    },
    required: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    metaData: {
      type: Object,
      default: null,
      required: false,
    },
    gaTracking: {
      type: Boolean,
      required: false,
      default: false,
    },
    gacategory: {
      required: false,
      default: 'Dezi Component - Checkbox',
    },
    gaaction: {
      required: false,
      default: 'Clicked Checkbox',
    },
    galabel: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    checkboxState() {
      if (this.model === undefined) { return this.checked; }
      if (Array.isArray(this.model)) { return this.model.indexOf(this.checkboxValue) !== -1; }
      return this.model;
    },
    setGaLabel() {
      return this.galabel || `${this.name} - ${this.checkboxValue}`;
    },
    classes() {
      return {
        'checkbox-disabled': this.disabled,
        'checkbox-active': this.checkboxState,
        'checkbox-lrg': this.size === 'lrg',
      };
    },
  },
  methods: {
    toggle() {
      if (this.disabled) return;

      let value = this.model;

      if (Array.isArray(value)) {
        value = value.slice();
        const i = value.indexOf(this.checkboxValue);

        if (i === -1) {
          value.push(this.checkboxValue);
        } else {
          value.splice(i, 1);
        }
      } else {
        value = !this.checkboxState;
      }

      this.gaEvent();

      this.$emit('change', value);
    },
    gaEvent() {
      if (this.gaTracking) {
        this.$helpers.gaEvent(this.gacategory, this.gaaction, this.galabel);
      }
    },
  },
  mounted() {
    if (this.checked && !this.checkboxState) {
      this.toggle();
    }
  },
};
</script>

<style lang="scss" scoped>
    .checkbox-group {
      @apply ut-my-3 ut-relative ut-cursor-pointer ut-text-transparent;

      .icon {
        @apply ut-absolute ut-flex ut-justify-center ut-rounded-full ut-items-center;
        height: 18px;
        width: 18px;
        // top:0px;
        // left: 0px;
        margin: auto;
      }

      &:hover .icon {
        background-color: rgba(37, 186, 104, 0.2);
        box-shadow: 0px 0px 0px 10px rgba(37, 186, 104, 0.2);
      }


      &.checkbox-active {
        @apply ut-text-neutral-001;
        &:before {
          @apply ut-bg-green-400;
        }
      }

      &:before {
        @apply ut-text-center ut-flex-shrink-0;
        content: '';
        @apply ut-border-green-400 ut-border-2 ut-border-solid;
        border-radius: 2px;
        height: 18px;
        width: 18px;
      }

      label {
        @apply ut-text-sm;
      }

      &.checkbox-lrg {

        label {
          @apply ut-text-base;
        }

      }

      //Hide input
      input {
        border: 0;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
      }


    }


</style>
